<template>
  <content-items-view
    content-type="reports"
    content-type-singular="report"
    content-name="Reports"
    content-name-singular="Report"
  />
</template>

<script>
import ContentItemsView from '@/views/content-item/content-items-view/ContentItemsView.vue'

export default {
  components: {
    ContentItemsView,
  },
}
</script>

<style scoped>

</style>
